import { useState } from 'react';

export const useModal = () => {
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info',
    showCancel: false,
    onConfirm: null,
    confirmText: 'OK',
    cancelText: 'Cancel'
  });

  const showModal = (title, message, type = 'info', onConfirm = null, showCancel = false, confirmText = 'OK', cancelText = 'Cancel') => {
    setModalConfig({
      isOpen: true,
      title,
      message,
      type,
      showCancel,
      onConfirm,
      confirmText,
      cancelText
    });
  };

  const showConfirm = (title, message, onConfirm, type = 'warning') => {
    setModalConfig({
      isOpen: true,
      title,
      message,
      type,
      showCancel: true,
      onConfirm,
      confirmText: 'Confirm',
      cancelText: 'Cancel'
    });
  };

  const closeModal = () => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
  };

  return {
    modalConfig,
    showModal,
    showConfirm,
    closeModal
  };
};

